import { transformProduct } from "~/features/productDetails/transformers/ProductDataTransformer";
import type { ProductDataDTO } from "~/domains/product/types/ProductDataDTO";
import type { ProductData } from "~/domains/product/types/ProductData";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

type ResponseType = {
  firstRelation: ProductDataDTO[];
  secondRelation: ProductDataDTO[];
};

export async function fetchFrequentlyBoughtTogetherProducts(
  code: string,
): Promise<{ first: ProductData[]; second: ProductData[] }> {
  const url = resolveApiUrl(`/p/${code}/frequentlyboughttogether`);

  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  if (response.redirected) {
    window.location.reload();
  } else if (response.ok) {
    const data: ResponseType = await response.json();
    return {
      first: data.firstRelation.map((product) => transformProduct(product as ProductDataDTO)),
      second: data.secondRelation.map((product) => transformProduct(product as ProductDataDTO)),
    };
  }
  throw new Error("Error fetching data");
}
